import { motion } from 'framer-motion';
import { Box, Typography, Container, Link, Grid, Stack } from '@mui/material';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';

import { bgState } from '../state';
import { Download } from '../components/DownloadLand';
import { ExpertCards } from '../components/ExpertCards';
import { FAQ } from '../components/FAQ';

import longScreen from '../assets/appscreen.jpg';

export function Landing() {
  const setBG = useSetRecoilState(bgState);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        mb: '6vh'
      }}>
      <Container sx={{
        mt: '6vh',
        flexGrow: 1,
      }}>
        <Grid
          container
          spacing={1}
          justifyContent={'space-evenly'}>

          <Grid item xs={12} sm={7}>
            <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                color: 'text.primary',
              }}>
              <Typography
                variant="h3"
                mb={4}
                textAlign={'left'}
                fontWeight={'bold'}>
                Your Privacy and Security in the Digital World
              </Typography>

              <Typography
                variant="h6"
                mb={1}
                textAlign={'left'}>
                Our VPN service creates an impenetrable shield for your online activity. Imagine a personal, hidden pathway on the internet, where only your data travels, protected from surveillance and interception.
              </Typography>

              <Typography
                variant="h6"
                mb={1}
                textAlign={'left'}>
                With WireDefense VPN, you can be confident in your digital freedom and tranquility. Whether you're connecting to Wi-Fi at a café, managing finances on the road, or just don’t want anyone knowing which sites you visit—we are guarding your privacy.
              </Typography>

              <Typography
                variant="h6"
                mb={1}
                textAlign={'left'}>
                Download our simple app for any of your gadgets and be protected in under a minute.
              </Typography>

              <Box sx={{ width: '100%', mt: '3vh' }}>
                <Download />
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={5} sx={{
            display: { xs: 'none', sm: 'flex' },
            justifyContent: 'center',
          }}>
            <Box
              sx={{
                // height: { xs: '12vmin', sm: '8vmin', md: '6vmin', xl: '6vmin' },
                maxWidth: { xs: '12vmin', sm: '90%', md: '60%', xl: '50%' },
                // height: 'auto',
                borderRadius: '20px',
                aspectRatio: '9/20',
              }}
            >
              <img
                src={longScreen}
                style={{ height: '100%', width: 'auto', borderRadius: '20px' }}
                alt='App Screen'
              />
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* <Box sx={{
        flexGrow: 1,
        position: 'relative',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        mt: '6vh',
      }}>
        <ExpertCards />
      </Box>

      <Container sx={{
        mt: '6vh',
        flexGrow: 1,
      }}>
        <FAQ />
      </Container> */}
    </Box >
  );
}

export default Landing;
